import React from 'react'

import { Typography, Divider, Zoom, makeStyles } from '@material-ui/core'
import {
  ErrorOutlineOutlined as WarningIcon,
  CheckCircleOutlineOutlined as SuccessIcon,
} from '@material-ui/icons'

import styles from './styles'

const useStyles = makeStyles(styles)

const CollapseHeader = ({ item }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.iconContainer}>
        <Zoom in={item.collapseSettings.edit}>
          <WarningIcon className={`${classes.icon} ${classes.iconWarning}`} />
        </Zoom>
        <Zoom in={!item.collapseSettings.edit}>
          <SuccessIcon className={`${classes.icon} ${classes.iconSuccess}`} />
        </Zoom>
      </div>

      {item.collapseSettings.edit ? (
        <Typography variant="h6">Item não salvo</Typography>
      ) : (
        <Typography variant="h6">
          {item.plan ? item.plan.name : item.description}
        </Typography>
      )}
      <Divider />
    </div>
  )
}

export default CollapseHeader
